import billing from './billing';
import profile from './profile';

export default {
  account: {
    tabs: {
      tab_1: 'Account',
      tab_2: 'Plan',
      tab_3: 'Terms and Conditions',
    },
    ...profile,
    ...billing,
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/account/account.js